import {
  Collection,
  ForEachModel,
  Model,
  useValue, WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty,
  WhenModelValue
} from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import React from 'react'
import { StaticFilter } from '@morningtrain/react-filters'

export default function ForecastDepartmentWageRatio () {
  const scheduleId = useValue('schedule_id')
  const weekDay = useValue('weekDay')

  return (
    <Collection resourceName='shifts.schedule' operationName='day_summary' operationContext={{ scheduleId: scheduleId }}>
      <StaticFilter name='schedule' value={scheduleId} />
      <WhenCollectionIsNotEmpty>
        <ForEachModel>
          <WhenModelValue name='weekDay' condition={weekDay}>
            <Displays.WageRatio name='salary_percentage_locked_budget' decimals={0} />
          </WhenModelValue>
        </ForEachModel>
      </WhenCollectionIsNotEmpty>
      <WhenCollectionIsEmpty>
        -
      </WhenCollectionIsEmpty>
    </Collection>
  )
}
